// Yat Admin user level can moderate all members
export const MODERATE_EVERYONE = 'Everyone';

// Group Owner can moderate all admins and users except self
export const MODERATE_ADMIN = 'Admin';

// Group Admin can moderate all members
export const MODERATE_MEMBER = 'Member';

// Group Members can not moderate any member
export const MODERATE_NO_ONE = 'NoOne';
